import { styled, Box } from "@mode/components";

export const Block = styled(Box, {
  transition: 'background 350ms ease-in-out',
  background: '$g2',
  padding: '$xxxxs',
  fontFamily: '$sans',
  fontSize: '$p2',
  fontWeight: '500',
  display: 'flex',
  alignItems: 'flex-end',
  color: '$g5',
  '& div': {
    background: '$g2',
    transition: 'background 350ms ease-in-out',
  },
  '&:hover, &:active': {
    background: '$g1',
    transition: 'background 350ms ease-in-out',
    '& div': {
      background: '$g1',
      transition: 'background 350ms ease-in-out',
    }
  },
  '@md': {
    padding: '$xxxs',
  }
})

export const BlockWrapper = styled('div', {
  py: '$sm',
  background: '$g3',
  '@md': {
    py: '$md'
  }
});

export const ContentContainer = styled('div', {
  width: '100%',
  px: '$xxs',
  py: '$xs',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  '@md': {
    width: '40%',
    padding: '$sm',
    paddingRight: '$xxxs',
  }
})

export const GridContainer = styled('div', {
  width: '100%',
  padding: '$xxs',
  display: 'grid',
  gridTemplateColumns: 'calc(30% - 12px) calc(40% - 10px) calc(30% - 12px)',
  gridTemplateRows: '180px 150px 150px',
  gridGap: '16px',
  '@md': {
    width: 'calc(64% - 80px)'
  }
})